import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class GMOUDto extends EpimsBaseEntityDto {

  GMOUId: string;
  @IsNotEmpty() GMOUTitle: string;
  @IsNotEmpty() GMOUCategoryId: string;
  @IsNotEmpty() GMOUTypeId: string;
  @IsNotEmpty() NegotiationDate: Date;
  @IsNotEmpty() SignatureDate: Date;
  @IsNotEmpty() OilBlocId: string;
  @IsNotEmpty() OilFieldId: string;
  @IsNotEmpty() StateId: string;
  @IsNotEmpty() LGAId: string;
  @IsNotEmpty() GMOUDescription: string;

}
